































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
  mixins: []
})

export default class Commitment extends Vue {

  @Prop({ default: false})
  isAgree

  get isAgreementChecked() {
    console.log(this.isAgree)
    return this.isAgree;
  }

  mounted() {
    if (this.$route.query.scroll && this.$route.query.scroll == "1") {
      this.$nextTick(() => {
        window.scrollTo(0, document.documentElement.scrollHeight);
      });
    }
  }
  
  toFillCommitment() {
    this.$router.push("/recruit/fillCommitment");
  }
}
